import React from 'react';
import type { FeatureHeaderProperties } from './index';
import { twMerge } from 'tailwind-merge';
import { parseJson } from '@/utils/parseJson';

interface DescriptionProps {
  className?: string;
  properties: FeatureHeaderProperties;
}

const Description: React.FC<DescriptionProps> = ({ className, properties }) => {
  const { description, description_style } = properties;
  const descriptionStyle = parseJson(description_style) ?? {};
  if (!description) return <></>;
  return (
    <div
      data-role="description"
      data-testid="wid-featured-header-description"
      className={twMerge('enki-body-base text-surface-100-fg-minor break-words', className)}
      style={{
        color: descriptionStyle.color
      }}>
      {description}
    </div>
  );
};

export default Description;
